import React from 'react';
import {
  ReferenceArrayInput,
  ListButton,
  SimpleForm,
  translate as t,
} from 'admin-on-rest';

import get from 'lodash/get';
import { CardActions, FlatButton } from 'material-ui';
import Refresh from 'material-ui/svg-icons/navigation/refresh';
import Card, { CardText } from 'material-ui/Card';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import CheckboxAndPriceInput from '../components/inputs/CheckboxAndPriceInput';
import CloneAssortment from '../components/CloneAssortment';
import ConnectedReferences from '../components/ConnectedReferences';
import VenuePreview from '../components/VenuePreview';
// import { TierFormConnected } from '../components/TieredProducts';
import { VenueList } from '../model/venues';
import SyncPreview from '../components/SyncPreview';
import FixedToolbar from '../components/FixedToolbar';

const VenueTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

const title = (resource) => (
  <span>{getTranslationByLocale(resource.title, 'en')}</span>
);

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const EditActions = ({ basePath, refresh, translate, ...props }) => (
  <CardActions style={cardActionStyle}>
    <VenuePreview {...props} />
    <SyncPreview {...props} />
    <EditButton
      {...props}
      record={{ id: props.match.params.id }}
      basePath="/venues"
    />
    <ListButton basePath={basePath} />
    <FlatButton primary label="Refresh" onClick={refresh} icon={<Refresh />} />
  </CardActions>
);

export const AssortmentEdit = t((props) => {
  const currentVenue = get(props, 'match.params.id', null);
  const filter =
    // Filter any products whose whitelists either have no venues or
    // contains the current venue
    {
      $or: [
        { venueWhitelist: currentVenue },
        { venueWhitelist: null },
        { venueWhitelist: { $size: 0 } },
      ],
    };

  return (
    <Edit
      actions={<EditActions {...props} />}
      title={<VenueTitle />}
      {...props}
    >
      <SimpleForm
        submitOnEnter={false}
        toolbar={<FixedToolbar />}
        redirect="edit"
      >
        <ConnectedReferences
          perPage={10000}
          references={(record) => [
            { name: 'categories' },
            {
              name: 'promoted-products',
              filter: { venueNames: record.name, markets: record.market._id },
            },
          ]}
        >
          <CloneAssortment hidden />
        </ConnectedReferences>
        <ReferenceArrayInput
          perPage={10000}
          source="products"
          reference="products"
          filter={{ provisional: { $ne: true }, ...filter }}
          allowEmpty
        >
          <CheckboxAndPriceInput
            {...props}
            optionText={title}
            optionValue="code"
          />
        </ReferenceArrayInput>
      </SimpleForm>
    </Edit>
  );
});

export const InactiveAssortmentList = t((props) => (
  <Card>
    <CardText>
      <h1>{props.translate('assortment-moved-title')}</h1>{' '}
      <p style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
        <a href="https://restaurant.pinchos.se">
          {props.translate('assortment-moved-text')}
        </a>
      </p>
    </CardText>
  </Card>
));

export const AssortmentList = (props) => {
  const { user, permissions } = props;
  const isSuperUser = user.superUser;
  const isProductManager =
    user.defaultVenue === 'se-hq-it' && permissions.name === 'productManager';
  const shouldSeeAllVenues = isSuperUser || isProductManager;
  const filter = shouldSeeAllVenues ? {} : { name: user.venues };
  return user ? <VenueList {...props} filter={filter} /> : null;
};
